import React, { Component, Fragment, useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Menu,
  Breadcrumb,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Divider,
  Spin,
  Tabs,
  Switch,
  Dropdown,
} from "antd";
import { useSelector, useDispatch } from 'react-redux';
import { getUserRoles, userRolesSelector, clearState, roleActive, roleInActive } from './userRoleSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined, EditOutlined } from "@ant-design/icons";
import Container from "../Layout/Container";
import { Link, useHistory, Redirect } from "react-router-dom";
import Can from '../../config/Can';
import ability from '../../config/ability';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

function callback(key) {
  // console.log(key);
}

const data = [
  {
    key: "1",
    name: "Receiving Clerk",
    id: "Clerk",
  },
  {
    key: "2",
    name: "Personal Assistant",
    id: "DD's & AD's",
  },
  {
    key: "3",
    name: "Officer",
    id: "CHD",
  },
  {
    key: "4",
    name: "Jr. Officer",
    id: "CHD",
  },
  {
    key: "4",
    name: "Sr. Officer",
    id: "Clerk",
  },
  {
    key: "4",
    name: "Commanding Officer",
    id: "DD's & AD's",
  },
  {
    key: "4",
    name: "Chief",
    id: "CHD",
  },
  {
    key: "4",
    name: "Head",
    id: "CHD",
  },
  {
    key: "4",
    name: "Super Head",
    id: "CHD",
  },
  {
    key: "4",
    name: "Jr. Head",
    id: "PHD",
  },
];

const ntop = "none";
const nbottom = "bottomCenter";
export default function UserRoles() {

  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);

  const { isFetching, isSuccess, isError, errorMessage, userRoles } = useSelector(
    userRolesSelector
  );
  const [rolesData, setDataSource] = useState([]);
  const [search, setSearch] = useState('');

  const [isRoleName, setRoleName] = React.useState("");


  // const getAllUserRoles = () => {
  //   dispatch(getUserRoles());

  // }



  // In the fifth row, other columns are merged into first column
  // by setting it's colSpan to be 0
  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    // if (index === 4) {
    //   obj.props.colSpan = 0;
    // }
    return obj;
  };





  const columns = [
    {
      title: "Appointments",
      dataIndex: "name",
      render: (text, row, index) => {
        return {
          children: <span style={{ marginBottom: 0 }}>{text}</span>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "Type",
      dataIndex: "id",
      render: renderContent,
    },
    {
      title: "Status",
      dataIndex: "active",
      className: ability.can('userRolesTab', 'enable/disableRoles') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="userRolesTab" a="enable/disableRoles">{<Switch
            // defaultChecked
            checked={text === "true" ? true : false}
            onChange={(e) => onChange(e, row)}
          />}</Can>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      fixed: "left",
      width: 100,
      className: ability.can('userRolesTab', 'editRoles') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="userRolesTab" a="editRoles"> <Dropdown
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
            arrow
          >
            <a
              style={{ color: "#c5c7cd", fontSize: 25 }}
              onClick={e => handleMenuClick(e, row)}
            >
              <MoreOutlined />
            </a>
          </Dropdown>
          </Can>
        };
      },
    },
  ];

  function handleMenuClick(e, rowData) {
    e.preventDefault();
    setRoleName("");
    setRoleName(rowData);
  }

  function handleEditMenuClick() {
    history.push({
      pathname: '/edit-appointment',
      state: { roleName: isRoleName }
    });

  }

  const menu = (
    <Menu onClick={handleEditMenuClick}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );


  const onChange = (checked, sendData) => {
    // console.log(`switch to ${checked} ==> ${sendData.name} `);
    const data = { "role": sendData.name };
    checked === true ? dispatch(roleActive(data)) : dispatch(roleInActive(data))
    dispatch(getUserRoles());
  };

  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getUserRoles());
  }, []);

  useEffect(() => {
    // if(userRoles.length==0){
    //   getAllUserRoles();
    // }

    if (isError) {
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(userRoles);
    }
  }, [isError, isSuccess, setLoading, userRoles, setDataSource]);




  let dataSource = isLoading
    ? []
    : rolesData ? rolesData.map(row => ({ name: row.name, id: row.userType[0] ? row.userType[0] : 'Clerk', active: row.active[0] })) : [];

  dataSource = dataSource ? dataSource.slice().sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) : [];
  return (
    <>
      <Container>
        <div
          className="site-layout-content"
          style={{ marginTop: 30, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
            <h2
              style={{
                paddingLeft: 16,
                paddingTop: 20,
                borderTop: "1px solid #dfe0eb",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                marginBottom: 0,
                backgroundColor: "#ffffff"
              }}
            >
              Appointments ({rolesData && rolesData.length > 0 ? rolesData.length : 0})
            </h2>
            <Space
              style={{
                padding: 16,
                width: "100%",
                borderLeft: "1px solid #dfe0eb",
                borderRight: "1px solid #dfe0eb",
                backgroundColor: "#ffffff"
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="10">
                  {/* <Search placeholder="Search process"  size="large"  /> */}
                  <Input
                    placeholder="Search by appointments"
                    size="large"
                    suffix={<SearchOutlined />}
                    onChange={e => {
                      const currValue = e.target.value;
                      setSearch(currValue);
                      const filteredData = userRoles.filter(entry =>
                        entry.name.includes(currValue)
                      );
                      setDataSource(filteredData);
                    }}
                  />
                </Col>
                <Col span="14" style={{ textAlign: "right" }}>

                  <Space>
                    <Can I="userRolesTab" a="createRoles">
                      <Link to="/add-appointment">
                        <Button
                          size="large"
                          style={{
                            borderRadius: 5,
                            padding: "6.4px 8px",
                            fontWeight: 600,
                            fontSize: 14,
                          }}
                          type="primary"
                          icon={<PlusOutlined />}
                        >
                          Add Appointment
                        </Button>
                      </Link>
                    </Can>
                  </Space>
                </Col>
              </Row>
            </Space>

            <Table
              columns={columns}
              pagination={{
                position: [ntop, nbottom],
                size: "small",
                defaultPageSize: 10,
                hideOnSinglePage: true,
              }}
              dataSource={dataSource}
              bordered
            />
          </div>
        </div>
      </Container>
    </>
  );
}
